import "./index.scss";
import { BENEFITS_LIST } from "./utils/constants";

export const PartnershipsBenefits = () => (
  <div className="partnerships-benefits">
    <div className="left-column">
      <p>
        While primarily a peer-to-peer site, GCX now partners with hundreds of
        national and regional merchants to help grow their gift card programs.
      </p>
      <p>
        By leveraging GCX as an incentive marketing platform, brands can connect
        directly with customers who buy gift cards for personal spending. In
        fact, we can competitively price those cards to “incentivize” buyers to
        lock in their dollars and guarantee future spend online and in your
        stores.
      </p>
      <p>
        In doing so, we turn a simple gift card into branded currency—a currency
        shoppers are keen to spend.
      </p>
    </div>
    <div className="right-column">
      {BENEFITS_LIST.map(({ icon, title, text }) => (
        <div className="partnerships-benefit" key={title}>
          <div className="title">
            <img src={icon} alt="benefit icon" />
            <p>{title}</p>
          </div>
          <p>{text}</p>
        </div>
      ))}
    </div>
  </div>
);
